import { render, staticRenderFns } from "./ProductBadge.vue?vue&type=template&id=7693212a&"
import script from "./ProductBadge.vue?vue&type=script&lang=js&"
export * from "./ProductBadge.vue?vue&type=script&lang=js&"
import style0 from "./ProductBadge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports